<template>
  <el-card class="box-card">
    <span slot="header">用工计划</span>
    <el-row :gutter="20">
      <!-- 左侧过滤面板 -->
      <el-col :span="5">
        <el-form :model="filter" label-position="top" ref="filter">
          <el-form-item label="园区" prop="parkId" size="small">
            <!-- 园区选框 -->
            <el-select
              v-model="filter.parkId"
              clearable
              placeholder="请选择园区"
            >
              <el-option
                v-for="p in parks"
                :key="p.id"
                :label="p.name"
                :value="p.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="时段">
            <el-radio-group v-model="filter.to">
              <el-radio v-for="end in ends" :key="end.val" :label="end.val">
                {{ end.lbl }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 右侧数据主体 -->
      <el-col :span="19" v-if="JSON.stringify(labors)!=='{}'">
        <el-calendar>
          <template slot="dateCell" slot-scope="{ date, data }">
            <div style="font-size: 20px; float: left" :class="data.type">
              {{ date.format('d') }}
              {{ data.day === todayString ? '今天' : '' }}
            </div>
            <div style="float: right; position: relative; margin-right: 10px">
              <el-progress
                v-if="labors[data.day]"
                type="dashboard"
                :color="colors"
                :percentage="
                  labors[data.day] * 15 > 100 ? 100 : labors[data.day] * 15
                "
                :width="64"
                :show-text="false"
              />
              <span
                style="
                  position: absolute;
                  left: 0;
                  right: 0;
                  z-index: 999;
                  line-height: 64px;
                  font-size: 20px;
                  text-align: center;
                  color: #3f3f3f;
                "
              >
                {{ labors[data.day] }}
              </span>
            </div>
          </template>
        </el-calendar>
      </el-col>
      <el-col :span="19" v-else>该园区目前没有用工计划。</el-col>
    </el-row>
  </el-card>
</template>

<script>
import { getParksInEnterprise } from '@/api/park2.js'
import { getLaborPlanByParkId } from '@/api/labor-plan.js'

export default {
  name: 'LaborPlan',
  data() {
    return {
      today: new Date().getTime(),
      todayString: new Date().format('yyyy-MM-dd'),
      filter: {
        parkId: undefined,
        to: undefined,
      },
      /**
       * 用工数据
       */
      labors: undefined,
      /**
       * 园区列表选项
       */
      parks: [],
      /**
       * 统计时间截止选项
       */
      ends: [],
      colors: [
        { color: '#1989fa', percentage: 20 },
        { color: '#5cb87a', percentage: 40 },
        { color: '#e6a23c', percentage: 60 },
        { color: '#f56c6c', percentage: 80 },
      ],
    }
  },
  computed: {
    enterpriseId() {
      return this.$store.getters.currentEnterprise.id
    },
  },
  mounted() {
    // 初始化园区下拉框
    getParksInEnterprise(this.enterpriseId).then((resp) => {
      this.parks = resp.data
    })
    //初始化时段选择器
    const { today, ends, filter } = this
    ends.push({ lbl: '未来一周', val: today + 1000 * 3600 * 24 * 7 })
    ends.push({ lbl: '未来半个月', val: today + 1000 * 3600 * 24 * 15 })
    ends.push({ lbl: '未来一个月', val: today + 1000 * 3600 * 24 * 30 })
    filter.to = ends[0].val

    // 默认取数据
    // this.fetchData()
  },
  methods: {
    fetchData() {
      if(this.filter.parkId===""||!this.filter.parkId){
        this.$message.error('请选择园区')
      }else{
      getLaborPlanByParkId(this.filter.parkId, this.filter.to).then(
        (resp) => {
          const map = {}
          // this.labors = resp.data
          resp.data.forEach((item) => {
            map[new Date(item.date).format('yyyy-MM-dd')] =
              item.labor.toFixed(1)
          })
          this.labors = map
        }
      )
      }
    },
    searchSubmit() {

      this.fetchData()
    },
  },
}
</script>

<style scoped>
.current-month {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/product/plan/Labor.vue